import React from 'react';
import { Edit3 } from 'lucide-react';

const NeedsMoreDetailPrompt = ({ originalPrompt, contextualPrompts, onEdit }) => {
  // Parse contextual prompts into list items
  const prompts = contextualPrompts 
    ? contextualPrompts.split('\n').filter(line => line.trim().startsWith('-')).map(line => line.replace(/^-\s*/, ''))
    : [
        "What you're deciding between specifically",
        "What the practical considerations are",
        "What signs or patterns you've noticed",
        "How each option feels to you"
      ];

  return (
    <div className="p-6 my-6 bg-purple-50 rounded-xl shadow-md relative border border-purple-200">
      <div className="mb-4">
        <h3 className="text-xl font-semibold text-purple-900 mb-3">
          💡 I'd love to help, but I need more to work with!
        </h3>
        
        <p className="text-gray-700 mb-4">
          You've asked <strong>"{originalPrompt}"</strong> but I don't know:
        </p>
        
        <ul className="list-disc ml-6 mb-4 text-gray-700 space-y-1">
          {prompts.map((prompt, index) => (
            <li key={index}>{prompt}</li>
          ))}
        </ul>
        
        <p className="text-gray-700 mb-4">
          Think of this like talking to a trusted friend - share what's on your mind, what you're weighing, how it feels, what you've noticed.
        </p>
        
        <p className="text-purple-700 font-semibold">
          Then I can give you real insights.
        </p>
      </div>
      
      <button
        onClick={onEdit}
        className="flex items-center gap-2 px-3 py-1.5 text-purple-500 hover:text-purple-600 text-sm border border-purple-200 rounded-lg hover:bg-purple-50 transition-colors"
      >
        <Edit3 className="w-4 h-4" />
        <span>Share More Details</span>
      </button>
    </div>
  );
};

export default NeedsMoreDetailPrompt;
